import React from 'react';
import { RegistrationForm } from '@features/auth/components/registration-form/RegistrationForm';

const RegistrationPage: React.FC = () => {
  return <RegistrationForm />;
};

export default RegistrationPage;
